import { Component, type ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

type State = {
  failed: boolean;
};

export default class CharacterPreviewBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(problem: unknown) {
    console.error('Character preview renderer failed safely.', problem);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="character-preview-fallback" role="status">
          Character preview unavailable. The employee runtime is unaffected.
        </div>
      );
    }

    return this.props.children;
  }
}
